import { render, staticRenderFns } from "./DeliveryResult.vue?vue&type=template&id=54c787af&"
import script from "./DeliveryResult.vue?vue&type=script&lang=js&"
export * from "./DeliveryResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports